import { useTranslation } from 'react-i18next'

import { DEADLINE_TEXT_COLOR_OVERDUE } from '../../../constants/date'
import { Status } from '../../Status'

import { REQUEST_CRITICAL_REASON_TEXT_KEY } from './RequestCriticalReasonTag.constants'

import * as styles from './RequestCriticalReasonTag.module.css'

function RequestCriticalReasonTag({ reason }) {
  const { t } = useTranslation()

  const textKey = REQUEST_CRITICAL_REASON_TEXT_KEY[reason?.key]

  return textKey ? (
    <Status
      className={styles.RequestCriticalReasonTag}
      text={t(textKey, { count: reason.days })}
      textColor={DEADLINE_TEXT_COLOR_OVERDUE}
    />
  ) : null
}

export default RequestCriticalReasonTag
